// src/data/blogs.js
const blogs = [
  {
    id: 1,
    title: "Benefits of Fly Ash Bricks over Clay Bricks",
    summary:
      "Fly ash bricks are stronger, eco-friendly, and more cost-effective than clay (red) bricks. They save material costs, reduce construction time, and are uniform in size.",
    date: "October 2025",
    image: "/images/flyash-vs-redbrick.webp",
    content: `
      Fly ash bricks are made from fly ash, cement, lime, and gypsum, while red bricks are made from clay and baked. 
      <br/><br/>
      <strong>Comparison:</strong>
      <ul>
        <li>Weight: Fly ash bricks are lighter than red bricks.</li>
        <li>Strength: Fly ash bricks have higher compressive strength.</li>
        <li>Eco-friendly: Fly ash bricks use industrial by-products; red bricks use fertile soil.</li>
        <li>Cost: Fly ash bricks reduce mortar consumption due to uniform size.</li>
      </ul>
      <img src="/images/flyash-bricks.webp" alt="Fly Ash Bricks" style="width:100%;margin-top:10px;"/>
      <img src="/images/red-bricks.webp" alt="Red Bricks" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 2,
    title: "Top Brick Suppliers in Dhanbad and Nearby Areas",
    summary:
      "Anil Flyash Bricks supplies high-quality fly ash bricks, blocks, and paver blocks across Dhanbad, Asansole, Madhupur, Deoghar, and nearby 100 km radius.",
    date: "September 2025",
    image: "/images/dhanbad-supplier.webp",
    content: `
      We focus on supplying premium construction materials to customers in Jharkhand and nearby West Bengal regions.
      <br/><br/>
      <strong>Products:</strong>
      <ul>
        <li>Standard Fly Ash Bricks</li>
        <li>Fly Ash Blocks</li>
        <li>Paver Blocks</li>
      </ul>
      <img src="/images/flyash-blocks.webp" alt="Fly Ash Blocks" style="width:100%;margin-top:10px;"/>
      <img src="/images/paver-blocks.webp" alt="Paver Blocks" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 3,
    title: "Why Fly Ash Blocks are Better than Red Clay Blocks",
    summary:
      "Fly ash blocks are uniform, lightweight, and eco-friendly compared to traditional clay blocks, providing stronger walls and reducing construction time.",
    date: "October 2025",
    image: "/images/flyash-block-vs-clay-block.webp",
    content: `
      <strong>Fly Ash Blocks vs Red Clay Blocks:</strong>
      <table border="1" cellpadding="8" cellspacing="0" style="width:100%;margin-top:10px;">
        <tr>
          <th>Feature</th>
          <th>Fly Ash Blocks</th>
          <th>Red Clay Blocks</th>
        </tr>
        <tr>
          <td>Weight</td>
          <td>Lightweight</td>
          <td>Heavy</td>
        </tr>
        <tr>
          <td>Strength</td>
          <td>High compressive strength</td>
          <td>Moderate</td>
        </tr>
        <tr>
          <td>Eco-friendly</td>
          <td>Yes, uses industrial waste</td>
          <td>No, uses fertile soil</td>
        </tr>
        <tr>
          <td>Uniformity</td>
          <td>Perfectly uniform</td>
          <td>Varies in size</td>
        </tr>
      </table>
      <img src="/images/flyash-block.webp" alt="Fly Ash Block" style="width:100%;margin-top:10px;"/>
      <img src="/images/clay-block.webp" alt="Clay Block" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 4,
    title: "Eco-Friendly Construction with Fly Ash Bricks and Blocks",
    summary:
      "Fly ash bricks and blocks reduce carbon footprint and promote sustainable building practices across Dhanbad, Asansole, and nearby areas.",
    date: "October 2025",
    image: "/images/eco-friendly-construction.webp",
    content: `
      Fly ash products use industrial by-products, reducing the need for clay and energy-intensive brick kilns. This ensures cleaner air and sustainable construction.
      <br/><br/>
      <img src="/images/construction-site.webp" alt="Construction Site with Fly Ash Bricks" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 5,
    title: "Paver Blocks: Durable Solutions for Outdoor Spaces",
    summary:
      "Our paver blocks are perfect for driveways, patios, and walkways, offering long-lasting durability and aesthetic appeal in Jharkhand and West Bengal.",
    date: "September 2025",
    image: "/images/paver-blocks.webp",
    content: `
      Paver blocks are resistant to wear and tear, provide excellent grip, and improve the look of your outdoor areas.
      <br/><br/>
      <img src="/images/paver-blocks-road.webp" alt="Paver Blocks Road" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 6,
    title: "Calculating Bricks & Blocks for Your Construction",
    summary:
      "Step-by-step guide to estimate the quantity of bricks, blocks, and paver blocks needed for your building project to save costs and reduce wastage.",
    date: "October 2025",
    image: "/images/brick-calculation.webp",
    content: `
      <strong>Steps:</strong>
      <ol>
        <li>Measure length, width, and height of walls.</li>
        <li>Calculate wall volume (length x height x thickness).</li>
        <li>Divide by brick/block volume to estimate quantity.</li>
      </ol>
      <img src="/images/brick-stack.webp" alt="Stack of Bricks" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 7,
    title: "Our Service Areas",
    summary:
      "We supply fly ash bricks, blocks, and pavers across Dhanbad, Asansole, Madhupur, Deoghar, and nearby 100 km radius including parts of West Bengal like Asansole and Durgapur.",
    date: "October 2025",
    image: "/images/service-area.webp",
    content: `
      <strong>Locations Covered:</strong>
      <ul>
        <li>Dhanbad</li>
        <li>Asansole (WB)</li>
        <li>Madhupur</li>
        <li>Deoghar</li>
        <li>Durgapur (WB)</li>
      </ul>
      <img src="/images/map-area.webp" alt="Service Map" style="width:100%;margin-top:10px;"/>
    `,
  },
  {
    id: 8,
    title: "Fly Ash Bricks vs Red Bricks: Cost & Efficiency",
    summary:
      "Detailed cost and efficiency comparison between fly ash bricks and traditional red bricks for construction projects in Jharkhand and West Bengal.",
    date: "October 2025",
    image: "/images/flyash-cost-comparison.webp",
    content: `
      <strong>Comparison Highlights:</strong>
      <ul>
        <li>Mortar usage: Less with fly ash bricks</li>
        <li>Construction speed: Faster with fly ash bricks</li>
        <li>Material cost: Economical due to uniformity</li>
        <li>Environmental impact: Fly ash bricks are sustainable</li>
      </ul>
      <img src="/images/flyash-bricks-cost.webp" alt="Fly Ash Bricks Cost Comparison" style="width:100%;margin-top:10px;"/>
      <img src="/images/red-bricks-cost.webp" alt="Red Bricks Cost Comparison" style="width:100%;margin-top:10px;"/>
    `,
  },
];

export default blogs;
